import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Button, Typography, Alert } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import MenuItem from "@mui/material/MenuItem";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckoutsQuery from "./CheckoutsQuery";
import CheckoutsList from "./CheckoutsList";
import {
  checkoutsApi
} from "../../../../../../services/accountingApi";

export default function Checkouts() {
  const [fetchedCheckoutsList, setFetchedCheckoutsList] = React.useState({ docs: [] });
  const [queryCheckoutsListData, setQueryCheckoutsListData] = React.useState({});
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا یکی از گزینه های بالا را انتخاب کنید و روی مشاهده کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getCheckoutsListFromBack(
      "getCheckoutsList",
      queryCheckoutsListData,
      PageAndPerPageValue
    );
  };


  const customToastify = (type, message) => {
    const options = {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    };

    if (type == "info") {
      toast.info(message, options);
      // console.log("type,message", type, message);
    }
    if (type == "success") toast.success(message, options);
    if (type == "warning") toast.warning(message, options);
    if (type == "error") toast.error(message, options);
  }

  const getCheckoutsListFromBack = async (request, data, paginateData = {}) => {
    setControlAlert({
      open: true,
      message: "درخواست ارسال شد",
      severity: "warning",
      SkeletonDisplay: "Block",
    });
    setFetchedCheckoutsList({ docs: [] });
    let paginate = { ...pageAndPerPage, ...paginateData };
    if (request == "getCheckoutsList") {
      let received = await checkoutsApi(data, paginate);
      // let received = fetchedStudentsListSample;
      // console.log("amir123456",received["data"]["data"])
      if (received.data.success) {
        setFetchedCheckoutsList(received["data"]["data"]);
        setControlAlert({
          open: true,
          message: "جواب آمد",
          severity: "warning",
          SkeletonDisplay: "none",
        });
        const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
          received["data"]["data"];
        const newValues = {
          totalPages,
          hasNextPage,
          hasPrevPage,
          page,
          totalDocs,
        };
        setPageAndPerPage({
          ...pageAndPerPage,
          ...paginateData,
          ...newValues,
        });
      } else {
        setControlAlert({
          open: true,
          message: "مشکلی پیش آمده است",
          severity: "warning",
          SkeletonDisplay: "none",
        });
      }
    }
  };


  return (
    <>
      <Accordion sx={{ mt: 1 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>فیلتر اطلاعات</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CheckoutsQuery
            setQueryCheckoutsListData={setQueryCheckoutsListData}
            getCheckoutsListFromBack={getCheckoutsListFromBack}
          />
        </AccordionDetails>
      </Accordion>
      <Divider />
      <Collapse in={controlAlert.open}>
        <Alert
          severity={controlAlert.severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setControlAlert({
                  open: false,
                  message: "",
                  severity: "info",
                  SkeletonDisplay: "none",
                });
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {controlAlert.message}
        </Alert>
      </Collapse>
      <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </Stack>
      <CheckoutsList
        fetchedCheckoutsList={fetchedCheckoutsList}
        pageAndPerPage={pageAndPerPage}
        setNumberPageAndPerPage={setNumberPageAndPerPage}
      />
      {/* <ToastContainer
        position="bottom-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </>
  );
}

// fetchedCheckoutsList
let fetchedStudentsListSample =
// {
//   data: {
//     success: true,
//     message: " درخواست با موفقیت انجام شد",
// data:
{
  docs: [
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "sdddddddddd",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "000000000",
      situation: "ppppppppppp",
      dateValidation: "2022-08-20T16:13:26.175Z",
    },
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "345345345345",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "11111111111",
      situation: "kkkkkkkkk",
      dateValidation: "2099-12-31T20:30:00.000Z",
    },
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "frgfgdfgdfg",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "22222222222",
      situation: "hhhhhhhhhhhh",
      dateValidation: "2099-12-31T20:30:00.000Z",
    },
  ],
  totalDocs: 50,
  limit: 1,
  totalPages: 25,
  page: 8,
  pagingCounter: 1,
  hasPrevPage: false,
  hasNextPage: true,
  prevPage: null,
  nextPage: 2,
}
//   },
// };
